function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 5.267C2.5 4.567 3.06 4 3.75 4h16.5c.69 0 1.25.567 1.25 1.267v11.151c0 .7-.56 1.267-1.25 1.267h-1.588l-.81 2a.497.497 0 01-.798.184l-2.386-2.184H3.75c-.69 0-1.25-.567-1.25-1.267V5.268zm6 5.702c0 .77-.616 1.394-1.375 1.394-.76 0-1.375-.624-1.375-1.394 0-.77.616-1.394 1.375-1.394.76 0 1.375.625 1.375 1.394zm5 0c0 .77-.616 1.394-1.375 1.394-.76 0-1.375-.624-1.375-1.394 0-.77.616-1.394 1.375-1.394.76 0 1.375.625 1.375 1.394zm3.625 1.394c.76 0 1.375-.624 1.375-1.394 0-.77-.616-1.394-1.375-1.394-.76 0-1.375.625-1.375 1.394 0 .77.616 1.394 1.375 1.394z",
  fill: "currentColor"
});

function SvgContactIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgContactIcon;